import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CrossIcon from "../IconComp/crossIcon";
import { LOGIN_SCREEN_ROUTE } from "../../routes";
import CreateTickIcon from "../IconComp/createTickIcon";

interface SuccessModalProps {
  open: any;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose(); // Close the modal
    navigate(LOGIN_SCREEN_ROUTE); // Navigate to the login screen
  };

  return (
    <Modal
      open={open}
      //onClose={handleClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the modal
          width: "90%",
          maxWidth: 583, // Sets a fixed width for larger screens
          height: "322px",
          bgcolor: "white",
          boxShadow: 44,
          maxHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 6, sm: 0 },
        }}
      >
        {/* Cross Icon for top-right corner */}
        <Box
          sx={{
            position: "absolute",
            top: "20px",
            right: "30px",
            cursor: "pointer",
          }}
          onClick={handleClose}
        >
          <CrossIcon />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box>
            <CreateTickIcon />
          </Box>

          <Box sx={{ fontSize: "24px", color: "#1E1D22", fontWeight: 500 }}>
            Your Pharmacy has been created Successfully.
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
